(function() {
  const selector = '[id^="product-form-"]';

  function reinitZepto() {
    if (window.ZeptoPersonalizer?.init) {
      console.log('[Zepto Fix] Reinitializing...');
      window.ZeptoPersonalizer.init();
    }
  }

  // 首次初始化
  document.addEventListener('DOMContentLoaded', reinitZepto);

  // 监听 DOM 变化，表单被替换后重新初始化
  const observer = new MutationObserver(() => {
    if (document.querySelector(selector)) {
      reinitZepto();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
